import {
  FieldSection,
  FieldSectionTitle,
  FormContainer,
  FormRoleConfContext,
  FormSearchField,
  FormTextField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { useWatch } from "react-hook-form"
import { formRoleConf } from "./Digital.formRoleConf"
import { DigitalEnum, type DigitalFormValues } from "./Digital.schema"
import {
  socialMediaTypesReferential,
  websiteServicesReferential,
} from "./referential"

export const Digital = () => {
  const conf = useRoleConf(formRoleConf)

  // Watch website fields to show required indicator dynamically
  const websiteValues = useWatch<DigitalFormValues, typeof DigitalEnum.WEBSITE>({
    name: DigitalEnum.WEBSITE,
  }) as DigitalFormValues["website"]

  const hasSiteUrl = !!websiteValues?.siteUrl
  const hasWebsiteService = !!websiteValues?.websiteService

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Présence digitale" />

        {/* WEBSITE */}
        <FieldSection
          title="Site internet"
          subtitle="Présence de votre officine sur internet"
          required={hasWebsiteService || hasSiteUrl}
        >
          <FormTextField<DigitalFormValues>
            name={`${DigitalEnum.WEBSITE}.${DigitalEnum.SITE_URL}`}
            label="URL du site"
            type="url"
            required={hasWebsiteService}
          />
          <FormSearchField<string, DigitalFormValues>
            name={`${DigitalEnum.WEBSITE}.${DigitalEnum.WEBSITE_SERVICE}`}
            label="Précisez le service"
            options={websiteServicesReferential}
            valueFormat="optionValue"
            required={hasSiteUrl}
          />
        </FieldSection>

        {/* SOCIAL NETWORKS */}
        <FieldSection
          title="Réseaux sociaux"
          subtitle="Renseigner les adresses web de vos réseaux sociaux"
        >
          {socialMediaTypesReferential.map(({ label, code }) => (
            <FormTextField<DigitalFormValues>
              key={code}
              name={`${DigitalEnum.SOCIAL_MEDIA_URLS}.${code}`}
              label={label}
            />
          ))}
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
